import React, { useState } from 'react';

const Header = (props) => {
  const { isMobile } = props;
  const [showMore, setShowMore] = useState(false);

  const handleClick = () => {
    if (showMore) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  };

  return (
    <header>
      <div className='header-container'>
        <div className='logo-text-container'>
          <div className='header-logo'>
            <a href='https://www.umamiinfo.com/'>
              <img
                src='/img/umami_logo_1.svg'
                alt='umami logo'
                target='_blank'
                rel='noreferrer'
              />
            </a>
          </div>
          <div className='header-text'>
            <p className='tagline'>
              Umami is the fifth taste. Neither salty
              <span
                className='rest'
                style={{
                  display: isMobile && !showMore ? 'none' : 'inline',
                }}
              >
                , sweet, sour nor bitter, it is the subtle flavour of tasty,
                savoury wholesomeness, discovered over 100 years ago.
              </span>
              <span
                className='dots'
                style={{
                  display: isMobile && !showMore ? 'inline' : 'none',
                }}
              >
                {' '}
                ...{' '}
              </span>
              <span
                className='more'
                style={{
                  display: isMobile && !showMore ? 'inline' : 'none',
                }}
                onClick={handleClick}
              >
                more
              </span>
              <span
                className='more'
                style={{
                  display: isMobile && showMore ? 'inline' : 'none',
                }}
                onClick={handleClick}
              >
                less
              </span>
            </p>
          </div>
        </div>

        <div className='social-container'>
          <div className='social-img'>
            <a
              href='https://www.umamiinfo.com/'
              target='_blank'
              rel='noreferrer'
            >
              <img src='/img/icon-umami.png' alt='umami icon'></img>
            </a>
          </div>
          <div className='social-img'>
            <a
              href='https://www.facebook.com/UmamiInformationCenter/'
              target='_blank'
              rel='noreferrer'
            >
              <img src='/img/icon-facebook.svg' alt='facebook logo'></img>
            </a>
          </div>
          <div className='social-img'>
            <a
              href='https://www.instagram.com/umamifun/'
              target='_blank'
              rel='noreferrer'
            >
              <img src='/img/icon-instagram.svg' alt='insta logo'></img>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
